import type { FaireProductEntity } from "../../entity_types/product";

export const p_zejradg8bh: FaireProductEntity = {
  token: "p_zejradg8bh",
  type: "product",
  name: "Pom Pom Fairy - Klee Kids Natural Mineral Play Makeup Kit",
  brandToken: "b_1wdyenfg",
  brandName: "Klee Naturals",
  imageUrl: "https://cdn.faire.com/fastly/664c5f3ca230afce041b1a94ad573a7b6d462e1a0ba3e8c5557619d803d70d33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ecf1ac2276e95d69b7a76d497a98197a1fb2b00f62cb847997452e8f7b264b0.jpeg",
    "https://cdn.faire.com/fastly/2414458e1aeabdd1f46bf9912622f9401be5eec004b3bf57eab4441a1139d0b3.jpeg",
    "https://cdn.faire.com/fastly/82c1a84c630541cf0d857da4e01e1f792f348e8513f65fd2fc326ae332c1e4a8.jpeg",
    "https://cdn.faire.com/fastly/bfcf27a94c9bff17a899151054ae3d750cb297c9d8d4cae3ced3b20d72246c64.jpeg",
    "https://cdn.faire.com/fastly/f9110f7967800e0ea0f2eb28efc7d7d1aa4ab68c7f48762a008a1b98157eb0e7.jpeg",
    "https://cdn.faire.com/fastly/ed67f0acd1098a527e72b209134f778c7deb8efa6f1d6418cd9642000ab8b38c.jpeg",
    "https://cdn.faire.com/fastly/10688acbdfa48cee3b8c03faa65af46d2933421170ccdd4b8b253af50242e814.png",
    "https://cdn.faire.com/fastly/64f10f78739d0bc651202469b02c2b5daa18a51831d12861e462cf586dc2f53d.jpeg",
    "https://cdn.faire.com/fastly/7797ef5c83d54033a6bed9e137f228b5c5297fe3bd8b026f47e526b5add7abd7.jpeg",
    "https://cdn.faire.com/fastly/0899d2924650aa965c315dc74e478db6a72ec9a4c2bcd195330c0bb2e7148a93.jpeg"
  ],
  priceDollars: 12.5,
  description: "Pretend play can now be worry-free with Klee Kids Natural Mineral Makeup, formulated with NO talc, NO parabens, NO synthetic dyes and NO synthetic fragrances. No animal testing and gluten free. Pom Pom Fairy includes the Cartwheel Purple loose-powder eyeshadow, All-Star Glow blush, and Watermelon Slice lip shimmer and Peach Cobbler lip shimmer. Made in USA.",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:36.205Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
